import React, { useEffect, useRef, useState } from "react";
import { Form, Input, message, Radio } from "antd";
import { Base64 } from "js-base64";
import { useNavigate } from "react-router-dom";
import AuthenticationService from "../Services/AuthenticationService";
import { APP_ROUTES } from "../PageRouting/pageRoutes";
import { AiOutlineUserSwitch } from "react-icons/ai";
import { generateAesKey } from "../utils/encryptPassword";
import Doxzonlogo from "../assets/logo/DoxzonLogo-Whitebackground.svg";
import ConsentServices from "../Services/ConsentServices";
import DoctorLogin from "./DoctorLogin";
import { useDispatch, useSelector } from "react-redux";
import { UpdateSelectedOption } from "../Redux/actions/commonActions";
import {
  getDataFromLocal,
  GETPATIENTDATASUCCESS,
} from "../Redux/actions/AuthActions";

const Login = ({ handleLoginModal, handleSignup }) => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [disable, setDisable] = useState(false);
  const [resendBtnClicked, setResendBtnClicked] = useState(false);
  const [isResendEnabled, setIsResendEnabled] = useState(true);
  const [disableTimer, setDisableTimer] = useState(true);
  const [timer, setTimer] = useState(180);
  const [patientloginType, setPatientloginType] = useState(true);
  const [patOtpScreen, setPatOtpScreen] = useState(false);
  const formRef = useRef();
  const verifyformRef = useRef();
  const inputRefs = useRef([]);
  const { selectedType } = useSelector((state) => state.common);
  const dispatch = useDispatch();
  const minutes = Math.floor(timer / 60);
  const seconds = timer % 60;

  useEffect(() => {
    if ((patOtpScreen || resendBtnClicked) && !disableTimer) {
      const timerInterval = setInterval(() => {
        setTimer((prevState) => {
          if (prevState === 0) {
            clearInterval(timerInterval);
            return 0;
          }
          return prevState - 1;
        });
      }, 1000);
      return () => {
        clearInterval(timerInterval);
        setTimer(180);
      };
    }
  }, [disableTimer, patOtpScreen, resendBtnClicked]);

  useEffect(() => {
    // written this useeffect to update the resend states and timer disabling
    // to handle resend button actions
    if (timer === 0) {
      setIsResendEnabled(true);
      setResendBtnClicked(false);
      setDisableTimer(true);
    }
  }, [timer]);

  const handleLogin = async (e, usertype) => {
    const { userCode, passWord } = formRef.current.getFieldValue();
    setDisable(true);
    let payload = {};
    if (!userCode || !passWord) {
      message.error("User Name/ Password is empty!");
      setDisable(false);
      return;
    }

    if (validatePhoneNumber(userCode)) {
      payload.userCode = userCode;
    } else if (validateEmail(userCode)) {
      payload.userCode = userCode;
    } else {
      message.error(
        "Please enter a valid email or 10-digit registered mobile number!"
      );
      setDisable(false);
      return;
    }

    payload.passWord = Base64.encode(passWord);
    const loginPayload = {
      password: payload.passWord,
    };
    if (usertype === "patient") {
      loginPayload.userId = `PAT_${payload.userCode}`;
    }

    try {
      const res = await AuthenticationService.TokenAuthentication(loginPayload);
      localStorage.setItem("access_token", res.data.access_token);
      localStorage.setItem("refresh_token", res.data.refresh_token);
      if (res.data.error === "1") {
        message.error(res.data.error_description);
        setDisable(false);
        return;
      }
      const encryptedPass = generateAesKey(passWord);
      let patientPayload = {
        currentVal: encryptedPass,
        userCode: payload.userCode,
      };
      const response = await AuthenticationService.Login(patientPayload);
      setDisable(false);
      localStorage.setItem("access_token", res.data.access_token);
      localStorage.setItem("refresh_token", res.data.refresh_token);
      localStorage.setItem(
        "patientData",
        JSON.stringify(response.data?.patient)
      );
      dispatch(getDataFromLocal());

      handleLoginModal();
      const consentPayload = {
        // account_Id: response?.data.patient.account_Id,
        // clinic_Id: response?.data.patient.clinic_Id,
        patientId: response?.data.patient.patientId,
      };

      const consentResponse = await ConsentServices.getconsentFilter(
        consentPayload
      );
      const data = consentResponse.data[0];
      if (consentResponse.data.length > 0) {
        if (
          data.termsCond === "P" ||
          data.termsCond === "N" ||
          data.privacyPolicy === "P" ||
          data.privacyPolicy === "N" ||
          data.shareMedWithDocs === "P" ||
          data.shareMedWithDocs === "N" ||
          data.shareMedWithHosp === "P" ||
          data.shareMedWithHosp === "N" ||
          data.shareEpresWithPharmacy === "P" ||
          data.shareEpresWithPharmacy === "N" ||
          data.shareEpresWithDiagnostics === "P" ||
          data.shareEpresWithDiagnostics === "N"
        ) {
          handleLoginModal();
          navigate(APP_ROUTES.LOGCONSENT);
        } else {
          if (window.location.pathname === "/") {
            handleLoginModal();
            navigate(APP_ROUTES.HOME);
          }
        }
      } else {
        handleLoginModal();
        navigate(APP_ROUTES.LOGCONSENT);
      }
    } catch (e) {
      setDisable(false);
      console.error(e);
    }
  };

  const handleForgotClick = (type) => {
    navigate(APP_ROUTES.FORGOTPASSWORD, { state: { type } });
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const validatePhoneNumber = (number) => /^\d{10}$/.test(number);

  const handleInputChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]$/.test(value) && index < 5) {
      inputRefs.current[index + 1].focus();
    } else if (!e.target.value && index >= 1) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleUserId = (e) => {
    const value = e.target.value;
    setUserId(value);
  };

  const generateOTP = async (userId) => {
    const tokenPayload = {
      password: "NA",
      userId: `P${userId}`,
    };

    try {
      const tokenRes = await AuthenticationService.TokenAuthentication(
        tokenPayload
      );
      if (tokenRes.data.error === "1") {
        // message.error(tokenRes.data.error_description);
        message.error("Please enter a registered mobile number.");
        setDisable(false);
        return;
      }
      localStorage.setItem("access_token", tokenRes.data.access_token);
      localStorage.setItem("refresh_token", tokenRes.data.refresh_token);
      let userPayload = {
        patientId: userId,
      };

      const response = await AuthenticationService.getPatientMobileOtp(
        userPayload
      );
      if (response.data === 1) {
        setPatOtpScreen(true);
        setDisableTimer(false);
        setDisable(false);
      }
    } catch (e) {
      console.error(e);
      setDisable(false);
      if (e && e?.response?.data?.status === 404) {
        message.error("Please enter a registered mobile number.");
      }
    }
  };

  const handleOtpVerification = async (e) => {
    e.preventDefault();
    setDisable(true);
    const { one, two, three, four, five, six } =
      verifyformRef.current.getFieldsValue();
    let finalNum = one + two + three + four + five + six;
    const encryptPassword = generateAesKey(finalNum);

    let verifyPayload = {
      numVal: encryptPassword,
      patientId: userId,
    };

    try {
      const response = await AuthenticationService.verifyPatientOtp(
        verifyPayload
      );
      localStorage.setItem(
        "patientData",
        JSON.stringify(response.data?.patient)
      );
      dispatch(getDataFromLocal());
      setDisable(false);
      handleLoginModal();
      const consentPayload = {
        // account_Id: response?.data.patient.account_Id,
        // clinic_Id: response?.data.patient.clinic_Id,
        patientId: response?.data.patient.patientId,
      };

      const consentResponse = await ConsentServices.getconsentFilter(
        consentPayload
      );
      const data = consentResponse.data[0];
      if (consentResponse.data.length > 0) {
        if (
          data.termsCond === "P" ||
          data.termsCond === "N" ||
          data.privacyPolicy === "P" ||
          data.privacyPolicy === "N" ||
          data.shareMedWithDocs === "P" ||
          data.shareMedWithDocs === "N" ||
          data.shareMedWithHosp === "P" ||
          data.shareMedWithHosp === "N" ||
          data.shareEpresWithPharmacy === "P" ||
          data.shareEpresWithPharmacy === "N" ||
          data.shareEpresWithDiagnostics === "P" ||
          data.shareEpresWithDiagnostics === "N"
        ) {
          handleLoginModal();
          navigate(APP_ROUTES.LOGCONSENT);
        } else {
          if (window.location.pathname === "/") {
            handleLoginModal();
            navigate(APP_ROUTES.HOME);
          }
        }
      } else {
        handleLoginModal();
        navigate(APP_ROUTES.LOGCONSENT);
      }
    } catch (e) {
      message.error(e.response.data.message);
      setDisable(false);
      return;
    }
  };

  const handleResend = async (e) => {
    e.preventDefault();
    setIsResendEnabled(false);
    setResendBtnClicked(true);
    setDisableTimer(false);
    setTimer(180);

    try {
      let userPayload = {
        patientId: userId,
      };
      await AuthenticationService.getPatientMobileOtp(userPayload);
    } catch (e) {
      console.error(e);
    }
  };

  const handleUserType = (e) => {
    const selectedOption = e.target.value;
    dispatch(UpdateSelectedOption(selectedOption));
  };

  const handlePatientlogType = () => {
    setPatientloginType(!patientloginType);
  };

  const handleNumberValidation = () => {
    setDisable(true);
    if (validatePhoneNumber(userId)) {
      generateOTP(userId);
    } else {
      message.error("Enter a valid 10 digit registered mobile number.");
      setDisable(false);
    }
  };

  return (
    <div className="w-full flex justify-center items-center bg-White">
      {
        <div className="w-full rounded-md xl:p-7 lg:p-6 p-2">
          <div className="flex justify-center items-center mb-2">
            <img src={Doxzonlogo} className="w-32 h-10" alt="appLogo" />
          </div>
          <div className="flex justify-center py-3">
            <Radio.Group
              value={selectedType}
              className="flex gap-4"
              onChange={handleUserType}
            >
              <Radio value="doctor">Doctor</Radio>
              <Radio value="patient">Patient</Radio>
            </Radio.Group>
          </div>

          <Form ref={formRef} className="flex flex-col p-5">
            {selectedType === "patient" ? (
              <div>
                {
                  //if patientlogintype is true it will be otp based login else password based login
                  patientloginType ? (
                    <div>
                      {
                        //if patotpscreen is true we will show otp entering screen. else show the mobile number entering field
                        patOtpScreen ? (
                          <>
                            <div>
                              <label className="text-lg font-medium">
                                OTP{" "}
                              </label>
                              <span style={{ color: "#FF000F" }}>*</span>
                            </div>
                            <div className="p-3">
                              <p className="text-sm font-extralight">
                                OTP will expire in{" "}
                                <span className="text-base text-iconBlue">{`${String(
                                  minutes
                                ).padStart(2, "0")}:${String(seconds).padStart(
                                  2,
                                  "0"
                                )}`}</span>
                                .
                              </p>
                            </div>
                            <Form ref={verifyformRef}>
                              <div className="w-full flex gap-2 items-center justify-evenly">
                                {[...Array(6)].map((_, index) => (
                                  <Form.Item
                                    key={index}
                                    name={
                                      [
                                        "one",
                                        "two",
                                        "three",
                                        "four",
                                        "five",
                                        "six",
                                      ][index]
                                    }
                                    className="w-1/5"
                                    rules={[
                                      {
                                        pattern: /^[0-9]{1}$/,
                                      },
                                    ]}
                                  >
                                    <Input
                                      maxLength={1}
                                      ref={(el) =>
                                        (inputRefs.current[index] = el)
                                      }
                                      onChange={(e) =>
                                        handleInputChange(e, index)
                                      }
                                      onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                          event.preventDefault();
                                        }
                                      }}
                                      className="outline-none border rounded-lg border-borderColor p-3 text-center font-medium text-xl"
                                    />
                                  </Form.Item>
                                ))}
                              </div>
                            </Form>
                            <div className="flex items-center gap-2">
                              <button
                                className={`w-full p-3 bg-lightBlue rounded-lg font-semibold disabled:cursor-not-allowed`}
                                disabled={!isResendEnabled}
                                onClick={handleResend}
                              >
                                Resend OTP
                              </button>
                              <button
                                disabled={disable}
                                className="w-full p-3 bg-[#189FAA] text-white rounded-lg font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
                                onClick={handleOtpVerification}
                              >
                                Verify OTP
                              </button>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="text-left w-[100%]">
                              {/* <label className="pr-3">User Name:</label> */}
                              <Form.Item name={"userCode"}>
                                <Input
                                  type="text"
                                  placeholder="UserId Or Mobile"
                                  suffix={
                                    <AiOutlineUserSwitch className="h-4 w-4 text-gray-500" />
                                  }
                                  className="h-10 w-full px-2 border border-gray-500 appearance-none bg-none  focus:outline-none focus:ring-0 disabled:opacity-50"
                                  style={{ background: "none" }}
                                  value={userId}
                                  onChange={handleUserId}
                                />
                              </Form.Item>
                            </div>
                            <div className="text-center mt-4 w-[100%]">
                              <button
                                disabled={disable}
                                onClick={handleNumberValidation}
                                className="w-full px-5 py-2 bg-[#189FAA] text-white rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
                              >
                                GET OTP
                              </button>
                            </div>
                          </>
                        )
                      }
                    </div>
                  ) : (
                    <>
                      <div className="text-left w-[100%]">
                        {/* <label className="pr-3">User Name:</label> */}
                        <Form.Item name={"userCode"}>
                          <Input
                            type="text"
                            placeholder="UserId Or Mobile"
                            suffix={
                              <AiOutlineUserSwitch className="h-4 w-4 text-gray-500" />
                            }
                            className="h-10 w-full px-2 border border-gray-500 appearance-none bg-none  focus:outline-none focus:ring-0 disabled:opacity-50"
                            style={{ background: "none" }}
                            value={userId}
                            onChange={handleUserId}
                          />
                        </Form.Item>
                      </div>
                      <div className="mt-5 text-left w-[100%]">
                        {/* <label className="pr-4">Password:</label> */}
                        <Form.Item name={"passWord"}>
                          <Input.Password
                            type="password"
                            placeholder="Password"
                            className="h-10 w-full px-2 border border-gray-500 appearance-none bg-none focus:outline-none focus:ring-0 "
                            style={{ background: "none" }}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                        </Form.Item>
                        <div
                          onClick={() => handleForgotClick(selectedType)}
                          className="text-end text-sm font-semibold text-[#189FAA] hover:underline cursor-pointer mt-2"
                        >
                          Forgot Password?
                        </div>
                      </div>
                      <div className="text-center mt-4 w-[100%]">
                        <button
                          disabled={disable}
                          onClick={(e) => handleLogin(e, selectedType)}
                          className="w-full px-5 py-2 bg-[#189FAA] text-white rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          Login
                        </button>
                      </div>
                    </>
                  )
                }

                {!patOtpScreen && (
                  <div className="w-full flex justify-center items-center mt-6">
                    {/* <hr className="w-[28%]" /> */}
                    <p
                      onClick={handlePatientlogType}
                      className="text-sm font-semibold text-[#189FAA] hover:underline cursor-pointer px-2"
                    >
                      {patientloginType
                        ? "Login with password"
                        : "Login with mobile"}
                    </p>
                    {/* <hr className="w-[28%]" /> */}
                  </div>
                )}
                <div className="w-full flex items-center mt-6">
                  <p className="text-sm font-semibold">
                    Don't have an account?{" "}
                    <span
                      className="hover:underline text-[#189FAA] cursor-pointer px-2"
                      onClick={() => handleSignup(selectedType)}
                    >
                      Sign Up
                    </span>
                  </p>
                </div>
              </div>
            ) : (
              <DoctorLogin
                handleLoginModal={handleLoginModal}
                handleSignup={handleSignup}
              />
            )}
          </Form>
        </div>
      }
    </div>
  );
};

export default Login;
